export default {
  customer: 'Клиент',
  customers: 'Клиенты',
  customersNew: 'Новые Клиенты',
  freeCustomersBase: 'Свободная база',
  customerGroup: 'Клиентская группа',
  noCustomers: 'Не найдено ни одного клиента',
  noContacts: 'По данному клиенту нет контактов',
  newContact: 'Новый контакт',
  createNewContact: 'Создать новый контакт',
  editContact: 'Изменение контакта',
  purchasing: 'Закупает',
  consignee: 'Принимает',
  pays: 'Платит',
  noInfoContact: 'По данному контакту нет никакой информации',
  pleaseWaitUntilCompleteScan: 'Идет процесс сканирования визитки...',
  searchByNameOrCodeOrInn: 'Поиск по названию, коду или ИНН',
  searchByNameOrPhone: 'Поиск по ФИО или номеру телефона',
  information: 'Информация',
  historyConsolidations: 'История закреплений',
  inn: 'ИНН',
  okpo: 'ОКПО',
  kpp: 'КПП',
  ogrn: 'ОГРН',
  legalStatus: 'Правовой статус',
  activity: 'Вид деятельности',
  subactivity: 'Вид поддеятельности',
  holding: 'Холдинг',
  bankDetails: 'Банковские данные',
  bankName: 'Наименование банка',
  bik: 'БИК',
  accountNumber: 'Лицевой счет',
  country: 'Страна',
  lastShipment: 'Последняя доставка',
  goToOrganizer: 'Перейти к задачам',
  goToCascade: 'Перейти в каскад',
  goToConstructionCards: 'Перейти к объектным картам',
  goToShipments: 'Перейти к доставкам',
  newContactCreated: 'Новый контакт создан',
  contactSuccessEdited: 'Контакт успешно изменен',
  term: 'Срок',
  primary: 'Основной',
  blocked: 'Заблокирован',
  stateContract: 'Госконтракт',
};
